"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleAcceptance = void 0;
var CookieAcknowledgeMethods = _interopRequireWildcard(require("./CookieAcknowledge"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _LocalStore = _interopRequireDefault(require("../../utils/storage/LocalStore"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _function = require("../../utils/type-checks/function");
var _isStorageSupported = require("../../utils/misc-checks/isStorageSupported");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  HandleAcceptance = (key, setter, isSupported) => {
    let sessionResult = null;
    if ((0, _string.isStringOfLength)(key)) {
      if (isSupported) {
        sessionResult = _LocalStore.default.SetItem(key, "true");
      }
      if ((0, _function.isFunction)(setter)) {
        setter(true);
      }
    }
    return sessionResult;
  };

/**
 * Component for display/accepting sitewide cookie acknowledgement
 *
 * @visibleName Cookie Acknowledgement
 * @author Jeff Stevens
*/
exports.HandleAcceptance = HandleAcceptance;
const CookieAcknowledge = props => {
  const {
      buttonLabel = "Accept",
      customKey = "CookieAcknowledgement",
      customTheme = {},
      disabled = false,
      fragmentId = "13i6iuq",
      headerTitle = "This website uses cookies",
      styles = {},
      testId
    } = props,
    [accepted, setAccepted] = (0, _react.useState)(_isStorageSupported.isLocalStorageSupported && _LocalStore.default.GetItem(customKey) === "true"),
    theme = merge(customTheme, (0, _styles.useTheme)()),
    sxStyles = merge({
      backgroundColor: "white",
      bottom: {
        xs: "0",
        sm: "1.8rem"
      },
      boxShadow: "0 0.6rem 4rem rgba(0, 0, 0, 0.3)",
      color: theme.palette.text.primary,
      display: "block",
      fontFamily: theme.fontFamilies.default,
      fontSize: {
        xs: "inherit",
        sm: "1.6rem"
      },
      padding: "2rem",
      position: "fixed",
      right: {
        xs: "0",
        sm: "1.8rem"
      },
      width: {
        xs: "100%",
        sm: "43rem"
      },
      zIndex: "1300",
      ".anchor--isPDF:after": {
        background: `url("${process.env.PUBLIC_URL}/general/images/icons/icon_pdf.svg") no-repeat`,
        bottom: "-0.2rem",
        content: "''",
        display: "inline-block",
        height: "1.8rem",
        margin: "0 0 0 0.4rem",
        position: "relative",
        width: "2rem"
      },
      ".CookieAcknowledge__header > h1": {
        color: "#3B4557",
        fontFamily: theme.fontFamilies.bold,
        fontSize: "2.2rem",
        margin: "0",
        textAlign: {
          xs: "center",
          sm: "left"
        },
        textTransform: "capitalize"
      },
      ".CookieAcknowledge__content": {
        margin: "2rem 0 3rem",
        textAlign: {
          xs: "center",
          sm: "left"
        }
      },
      ".CookieAcknowledge__footer": {
        margin: "0",
        textAlign: {
          xs: "center",
          sm: "left"
        }
      }
    }, styles),
    result = !accepted && !disabled ? /*#__PURE__*/_react.default.createElement(_material.Container, {
      "data-testid": testId,
      sx: sxStyles,
      component: "div",
      role: "dialog"
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "CookieAcknowledge__header",
      component: "header"
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "h1"
    }, headerTitle)), /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      className: "CookieAcknowledge__content",
      htmlElem: "div",
      id: fragmentId
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "CookieAcknowledge__footer",
      component: "footer"
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      onClick: () => CookieAcknowledgeMethods.HandleAcceptance(customKey, setAccepted, _isStorageSupported.isLocalStorageSupported),
      sx: {
        margin: "0"
      },
      variant: "primary"
    }, buttonLabel))) : "";
  return result;
};

// Define propTypes;
CookieAcknowledge.propTypes = {
  /** Button Label (Default Label: "Accept") */
  buttonLabel: _propTypes.default.string,
  /** Key for storing acceptance in localStorage (Default Value: "CookieAcknowledgement") */
  customKey: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to disable cookie acknowledge display (Default Value: false) */
  disabled: _propTypes.default.bool,
  /** Content Fragment ID (Default Value: "13i6iuq") */
  fragmentId: _propTypes.default.string,
  /** Header Text (Default Value: "This website uses cookies") */
  headerTitle: _propTypes.default.string,
  /** Custom Style Object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = CookieAcknowledge;